import { render } from "./PlanSuccessComponent.vue?vue&type=template&id=53cc6108"
import script from "./PlanSuccessComponent.vue?vue&type=script&lang=js"
export * from "./PlanSuccessComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__